/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LastExecutionStats { 
    /**
     * The amount of milleseconds it took to complete the last run
     */
    completion_time_milliseconds?: number;
    /**
     * Any error message associated with the last job run
     */
    error_message?: string;
}

